export function authDestination(user) {
  if (user.onboarding_required) return '/onboarding';
  if (user.acct_team_uuid) return '/dashboard';
  return user.platform_permissions?.includes('platform.statistics.read') ? '/admin' : '/403';
}
